import axios from 'axios'
import { ElNotification, ElMessageBox, ElMessage, ElLoading } from 'element-plus'
import {tansParams} from '@/utils'
import cache from '@/utils/cache'


axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: process.env.VUE_APP_ENV === 'dev' ? 'http://127.0.0.1:8044/' : 'http://www.alanyzx.cn:8044/',
  baseURL: 'http://www.alanyzx.cn:8044/',
  // 超时
  timeout: 10000
})

// request拦截器
service.interceptors.request.use(config => {
  config.headers = {    'Content-Security-Policy': "default-src 'self' https:; script-src 'self' 'unsafe-inline';"  }
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params);
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  if ((config.method === 'post' || config.method === 'put')) {
    const requestObj = {
      url: config.url,
      data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
      time: new Date().getTime()
    }
    const sessionObj = cache.session.getJSON('sessionObj')
    if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
      cache.session.setJSON('sessionObj', requestObj)
    }
  }
  return config
}, error => {
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // console.log(res,'res123');
    // 未设置状态码则默认成功状态
    const code = res.data.code || '200';
    // 获取错误信息
    const msg = res.data.code
    // 二进制数据则直接返回
    if (res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer') {
      return res.data
    }
    // if (code === 401) {
    //   // location.href = '/login';
    //   return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    // } else if (code === '400') {
    //   ElMessage({ ElMessage: msg, type: 'error' })
    //   return Promise.reject(new Error(msg))
    // } else if (code === 601) {
    //   ElMessage({ ElMessage: msg, type: 'warning' })
    //   return Promise.reject('error')
    // } else if (code !== '200') {
    //   return Promise.reject('error')
    // } else {
    //   return res.data
    // }
    return res.data.data
  },
  error => {
    console.log('err' + error)
    let { ElMessage } = error;
    if (ElMessage == "Network Error") {
      ElMessage = "后端接口连接异常";
    } 
    return Promise.reject(error)
  }
)

export default service
